var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connection-error"},[_vm._v(" "+_vm._s(_vm.$t('connection_error'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }